// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4198":"css/app.6761","4928":"css/admin-app.6761"}[chunkId] + ".css";
};